<template>
  <div class="d-flex flex-column mt-2 sticky-box justify-center">
    <v-btn
      v-if="showUpdateSignatureStatusButton"
      outlined
      tile
      large
      class="non-text-transformation link mb-4"
      data-cy="button-refresh-state"
      :loading="loadingSignature && !loadingCancelation"
      :disabled="loadingCancelation"
      @click="updateSignatureStatus()"
    >
      {{ $t('SIGNATURE_STATE_BTN') }}
    </v-btn>
    <v-btn
      v-if="isSignatureCancellationAllowed"
      color="primary"
      class="link non-text-transformation"
      large
      tile
      outlined
      data-cy="button-cancel-sign"
      :loading="loadingCancelation"
      @click="cancelSign()"
    >
      {{ $t('SIGN_CANCEL_BUTTON') }}
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { REQUEST_CONTRACT_STATUS, CANCEL_SIGN } from '@/store/modules/offer/actions'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { OFFER_STATUS, TERMINAL_SIGNATURE_STATUS } from '@/helpers/constants'

export default {
  name: 'SignatureButtons',
  data() {
    return {
      loadingSignature: false,
      loadingCancelation: false,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    ...mapState('process', ['signStatus']),
    offerId() {
      return this[GET_OFFER_ITEM]('offerId')
    },
    offerStatus() {
      return this[GET_OFFER_ITEM]('status')
    },
    isTerminalSignatureStatus() {
      return TERMINAL_SIGNATURE_STATUS.includes(this.signStatus)
    },
    showUpdateSignatureStatusButton() {
      return (
        (this.offerStatus === OFFER_STATUS.SYNCHRONIZED ||
          this.offerStatus === OFFER_STATUS.SIGNING ||
          this.offerStatus === OFFER_STATUS.SIGNED) &&
        !this.isTerminalSignatureStatus
      )
    },
    isSignatureCancellationAllowed() {
      return this.offerStatus === OFFER_STATUS.SIGNING && !this.isTerminalSignatureStatus
    },
  },
  methods: {
    ...mapActions('offer', [REQUEST_CONTRACT_STATUS, CANCEL_SIGN]),
    ...mapActions('alerts', ['createAlert']),
    async updateSignatureStatus() {
      this.loadingSignature = true

      const response = await this[REQUEST_CONTRACT_STATUS]({
        offerId: this.offerId,
      })

      this.loadingSignature = false

      return response
    },
    async cancelSign() {
      this.loadingCancelation = true

      const updatedSignatureStatusResponse = await this.updateSignatureStatus()

      if ('error' in updatedSignatureStatusResponse) {
        this.createAlert({
          type: 'error',
          contentKey: 'SIGNATURE_UPDATE_ERROR',
          details: updatedSignatureStatusResponse.error,
        })
      } else {
        if (this.isSignatureCancellationAllowed) {
          const cancelSignResponse = await this[CANCEL_SIGN]({
            offerId: this.offerId,
          })

          if ('error' in cancelSignResponse) {
            this.createAlert({
              type: 'error',
              contentKey: 'SIGNATURE_CANCEL_ERROR',
              details: cancelSignResponse.error,
            })
          } else {
            await this.updateSignatureStatus()
          }
        } else {
          this.createAlert({
            type: 'error',
            contentKey: 'SIGNATURE_CANCEL_NOT_ALLOWED',
          })
        }
      }

      this.loadingCancelation = false
    },
  },
  mounted() {
    this.updateSignatureStatus()
  },
}
</script>
